// extracted by mini-css-extract-plugin
export default {"sidebar":"AdminSidebar_sidebar__ZZspg","nav":"AdminSidebar_nav__s3LVY","navItem":"AdminSidebar_navItem__+sL-N","active":"AdminSidebar_active__vidPD"};